import { DeviceSetting } from '../device-setting.model';
import { DeviceSettingActions, DeviceSettingActionTypes } from '../actions/device-setting.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(
  state = initialState,
  action: DeviceSettingActions
): State {
  switch (action.type) {
    
    case DeviceSettingActionTypes.LoadDeviceSetting: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSettingActionTypes.UpdateDeviceSetting: {
      return {...state, Loaded: false, Loading: true};
    }

    case DeviceSettingActionTypes.UpdateDevicesSettingFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default: {
      return state;
    }
  }
}

